export enum EGroupTypes {
  NONE = 'NONE',
  G1 = 'G1',
  G2 = 'G2'
}
